import { useEffect, useState } from "react";

import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { deleteNodesFromNodeset } from "@src/cloud-connect/use-cases/delete-nodes-from-nodeset";

import inactiveDeleteIcon from "@src/assets/svg/delete-inactive-blue-icon.svg";
import deleteIcon from "@src/assets/svg/delete-blue-icon.svg";

export const useControlBarDeleteButtonHook = () => {
  const machineStructureNodeset = getMachineStructureNodeset();

  const [selectedSize, setSelectedSize] = useState(
    machineStructureNodeset.getSelectedNodeCount(),
  );

  useEffect(() => {
    const updateSelectedSize = () => {
      setSelectedSize(machineStructureNodeset.getSelectedNodeCount());
    };

    machineStructureNodeset.addObserver(updateSelectedSize);
    return () => {
      machineStructureNodeset.removeObserver(updateSelectedSize);
    };
  }, [machineStructureNodeset]);

  const icon = selectedSize ? deleteIcon : inactiveDeleteIcon;
  const disabled = !selectedSize;

  return {
    icon,
    disabled,
    deleteNodesFromNodeset,
  };
};
